'use strict';

import template from './corteExcepcional.html'
import controller from './corteExcepcional.controller'

const CorteExcepcionalComponent = {
  template,
  controller
}

export default CorteExcepcionalComponent



// WEBPACK FOOTER //
// ./src/app/components/soporte/corteExcepcional/corteExcepcional.component.js